export default __webpack_public_path__ + "static/media/salesforce-background.e27a2b9f.svg";